import { useState, useEffect } from "react";
import { API } from "@/App";
import axios from "axios";
import { Loader2, Code2 } from "lucide-react";

const TraveldeskItinerarios = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCode = async () => {
      try {
        const res = await axios.get(`${API}/traveldesk/itinerarios`, { withCredentials: true });
        setCode(res.data.code || "");
      } catch (err) {
        console.error("Error loading traveldesk code:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCode();
  }, []);

  if (loading) {
    return (
      <div className="p-6 flex items-center justify-center h-[calc(100vh-100px)]">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!code) {
    return (
      <div className="p-6 flex flex-col items-center justify-center h-[calc(100vh-100px)] text-center" data-testid="traveldesk-itinerarios-empty">
        <Code2 className="w-16 h-16 text-slate-300 mb-4" />
        <h2 className="text-xl font-semibold text-slate-700 mb-2">Itinerarios</h2>
        <p className="text-slate-500 max-w-md">
          No hay contenido configurado. El administrador puede agregar el código HTML/iframe desde Configuración → Opciones → Traveldesk.
        </p>
      </div>
    );
  }

  return (
    <div className="p-4 h-[calc(100vh-32px)]" data-testid="traveldesk-itinerarios-page">
      <iframe
        srcDoc={code}
        className="w-full h-full rounded-lg border-0 bg-white"
        title="Itinerarios"
      />
    </div>
  );
};

export default TraveldeskItinerarios;
